import { render } from "./PerformanceTrendsChart.vue?vue&type=template&id=26bd699b&scoped=true"
import script from "./PerformanceTrendsChart.vue?vue&type=script&lang=js"
export * from "./PerformanceTrendsChart.vue?vue&type=script&lang=js"

import "./PerformanceTrendsChart.vue?vue&type=style&index=0&id=26bd699b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26bd699b"]])

export default __exports__